import { ISolicitudDocumentoTecnicoAsignarModel } from "../../interfaces/solicitud/documento-tecnico/ISolicitudDocumentoTecnicoAsignarModel";
import { ISolicitudDocumentoModel } from "../../interfaces/solicitud/documento/ISolicitudDocumentModel";

export class SolicitudDocumentoTecnicoAsignarModel implements ISolicitudDocumentoTecnicoAsignarModel{
    documento?: ISolicitudDocumentoModel;
}